import { Center, Loader, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import PageShell from '../components/PageShell';
import { useResolvedProgram } from '../hooks/useResolvedProgram';
import NotFoundPage from './NotFoundPage';

export default function ParticipationSuccessPage() {
  const { data: config, isLoading, error } = useResolvedProgram();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  const participationConfig = config?.voucherParticipationRequest;
  const success = participationConfig?.pages.success;

  if (error || !config || !success) {
    return <NotFoundPage />;
  }

  return (
    <PageShell
      config={config}
      containerSize="lg"
      headerEyebrow={config.theme.displayName}
      headerTitle={participationConfig.pages.title}
      showFooter
      contentSurface={config.theme.contentSurface === true}
    >
      <Paper p="xl" withBorder className="portal-panel">
        <Stack align="center" gap="md" py="lg" ta="center">
          <ThemeIcon color="green" size={60} radius="xl" variant="light">
            <IconCheck size={32} />
          </ThemeIcon>
          <Title order={2}>{success.title}</Title>
          <Text size="lg" c="dimmed" maw={560}>{success.message}</Text>
        </Stack>
      </Paper>
    </PageShell>
  );
}